<!DOCTYPE html>
<html lang="zh">
  <head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1">
    <meta name="renderer" content="webkit">
    <link rel="icon" href="%VITE_FAVICON_URL%">
    <meta name="viewport" content="width=768, initial-scale=1, shrink-to-fit=no, viewport-fit=cover">
    <title>开放原子开源基金会管理后台</title>
  </head>
  <body>
    <div id="app"></div>
    <script type="module" src="/src/main.ts"></script>
  </body>
</html>
